import { positionKeys } from "./publicKeys";


export default function calculateNumberOfFaPlayer(playerInfos) {

    let numberOfFaPlayer = 0

    for (const positionKey of positionKeys) {
        const player = playerInfos[positionKey]

        if(player) {
            if(player.isFa) {
                numberOfFaPlayer += 1
            }
        }
    }

    return numberOfFaPlayer
}